import {
  axios,
  config
} from '../api'
import store from '../store'

let report = {}

// 获取商铺报表的项目下拉框数据
report.getProjNameList = () => {
  return axios('post', config.API_URL + '/api/Report/GetProjNameList', {},{})
}


report.GetReport1 = (_name) => {
  return axios('post', config.API_URL + '/api/Report/GetReport1', {},{
    projName:_name
  })
}


report.GetReport2 = (_year) => {
  return axios('post', config.API_URL + '/api/Report/GetReport2', {},{
    year:_year
  })
}

report.GetReport3 = (_cycleType,_date) => {
  return axios('post', config.API_URL + '/api/Report/GetReport3', {},{
    cycleType:_cycleType,
    date:_date
  })
}

report.GetReport4 = (_projName,_year) => {
  return axios('post', config.API_URL + '/api/Report/GetReport4', {},{
    projName:_projName,
    year:_year
  })
}


report.GetReport5 = (_cycleType,_date) => {
  return axios('post', config.API_URL + '/api/Report/GetReport5', {},{
    cycleType:_cycleType,
    date:_date
  })
}


export default report



